import { LevelData } from '../level-data';

export const level18: LevelData = {
    name: 'The Needle',
    timeLimit: 115,
    track: [
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
